var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89583 8.23958C5.39583 11.1875 7.8125 13.5937 10.7604 15.1042L13.0521 12.8125C13.3333 12.5312 13.75 12.4375 14.1146 12.5625C15.2812 12.9479 16.5417 13.1562 17.8333 13.1562C18.4062 13.1562 18.875 13.625 18.875 14.1979V17.8333C18.875 18.4062 18.4062 18.875 17.8333 18.875C8.05208 18.875 0.125 10.9479 0.125 1.16667C0.125 0.59375 0.59375 0.125 1.16667 0.125H4.8125C5.38542 0.125 5.85417 0.59375 5.85417 1.16667C5.85417 2.46875 6.0625 3.71875 6.44792 4.88542C6.5625 5.25 6.47917 5.65625 6.1875 5.94792L3.89583 8.23958Z",
    fill: "#051C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCallOutline);
export default __webpack_public_path__ + "static/media/blueCallOutline.070cd1769b809dd79f1d6f6bf9761218.svg";
export { ForwardRef as ReactComponent };